"use strict";
/* globals module */
/**
 * @module commerceCouponRoute
 * @description Baasic Commerce Coupon Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Coupon Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var CommerceCouponRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceCouponRoute, _super);
    function CommerceCouponRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/coupons/{?searchQuery,page,rpp,sort,embed,fields,productId,productCategoryId,active}';
        _this.getRoute = 'commerce/coupons/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/coupons';
        _this.updateRoute = 'commerce/coupons/{id}';
        _this.deleteRoute = 'commerce/coupons/{id}';
        _this.findCouponUseRoute = 'commerce/coupons/{id}/uses/{?embed,fields}';
        return _this;
    }
    /**
     * Parses find commerce coupon route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `productId` - A product id.
     * - `productCategoryId` - A product category id.
     * - `active` - flag is coupon active or not
     * @method
     * @example commerceCouponRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceCouponRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceCouponRoute.get(id, options);
     **/
    CommerceCouponRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce coupon route; this URI template does not expose any additional options.
     * @method
     * @example commerceCouponRoute.create();
     **/
    CommerceCouponRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce coupon route; this URI template does not expose any additional options.
     * @method
     * @example commerceCouponRoute.update(data);
     **/
    CommerceCouponRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce coupon route; this URI template does not expose any additional options.
    * @method
    * @example commerceCouponRoute.delete(data);
    **/
    CommerceCouponRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses find route; this route doesn't expose any properties.
     * @method
     * @example commerceCouponRoute.findCouponUses(couponId, options);
     **/
    CommerceCouponRoute.prototype.findCouponUses = function (couponId, options) {
        return _super.prototype.baseGet.call(this, this.findCouponUseRoute, couponId, options);
    };
    var _a;
    CommerceCouponRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceCouponRoute);
    return CommerceCouponRoute;
}(common_1.BaseRoute));
exports.CommerceCouponRoute = CommerceCouponRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
